import axios from 'axios';
import { config } from './constants';

const fetchData = async (endpoint, token, method = 'GET', body) => {
    const { data } = await axios({
        method,
        url: `${config.api}${endpoint}`,
        headers: {
            'x-api-key': token,
            'Content-Type': 'application/json',
        },
        data: body,
    });

    if (!data || data.error) {
        throw new Error(`Failed: ${endpoint}`);
    }

    return data.data;
};

const fetchCMSData = async () => {
    try {
        const token = process.env.REACT_APP_API_KEY;
        const siteId = config.adsignId;

        if (!token) return;

        const [pois, categories, media, info, tags] = await Promise.all([
            fetchData(`/poi/list?siteId=${siteId}`, token),
            fetchData(`/poiCategory/list?siteId=${siteId}`, token),
            fetchData(`/media/filter`, token, 'POST', {
                siteId,
                categoryId: 'all',
                type: 'published',
            }),
            fetchData(`/information/list?siteId=${siteId}`, token),
            fetchData(`/tag?siteId=${siteId}`, token),
        ]);

        const filteredPois = pois.filter((poi) => poi.approval !== 'pending');

        return {
            pois: filteredPois,
            categoryPois: categories,
            media,
            information: info,
            tags,
        };
    } catch (err) {
        // console.error('Failed to fetch CMS data:', err);
        // throw err;
    }
};

export default fetchCMSData;
